module.exports = __webpack_public_path__ + "img/manage-cancel-icon.59645409.svg";